"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimeCoder = void 0;
const luxon_1 = require("luxon");
function isIsoDate(str) {
    return /\d{4}-\d{2}-\d{2}/.test(str);
}
function isIsoDateTime(str) {
    return /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str);
}
exports.DateTimeCoder = {
    testDecode: (object) => typeof object === "string" && (isIsoDate(object) || isIsoDateTime(object)),
    decode: (object) => {
        const dt = luxon_1.DateTime.fromISO(object, { zone: "utc" });
        if (!dt.isValid)
            throw new Error("Invalid Datetime: " + object);
        return dt;
    },
    testEncode: (object) => luxon_1.DateTime.isDateTime(object),
    encode: (object) => {
        const utc = object.toUTC();
        return utc.equals(utc.startOf("day")) ? utc.toISODate() : utc.toISO();
    }
};
//# sourceMappingURL=datetime.js.map